"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUCKET_LABELS = exports.BUCKET_DEBT_PAID_COPY = exports.BUCKET_DEBT_PAYOFF_COPY = exports.FLEXIBLE_SPENDING_TARGET_HINT_COPY = exports.FLEXIBLE_SPENDING_TARGET_COPY = exports.BUCKET_SPLASH_COPY = exports.BUCKET_SAVINGS_COPY = exports.BUCKET_WANTS_COPY = exports.BUCKET_NEEDS_COPY = exports.BUCKET_INCOME_COPY = void 0;
exports.bucketLabel = bucketLabel;
exports.relabelBucket = relabelBucket;
/**
 * Bucket DISPLAY names, one source for both clients (Anthony's renames, feedback #9;
 * moved to shared in Transactions Phase 2, 2026-10-08, rule 17). Display-layer only:
 * category data, API keys and DB rows keep their original names (needs/wants/savings/…).
 *
 * Each name is its own `*_COPY` constant so the copy inventory lists it (it does not read
 * object values); the map below is built from them.
 *
 * Anthony's verbatim renames: Needs → "Bills & Essentials", Wants → "Flexible Spending",
 * Savings → "Savings & Goals", Splash Fund stays, Debt Allocation → "Debt Payoff".
 */
exports.BUCKET_INCOME_COPY = "Income";
exports.BUCKET_NEEDS_COPY = "Bills & Essentials";
exports.BUCKET_WANTS_COPY = "Flexible Spending";
exports.BUCKET_SAVINGS_COPY = "Savings & Goals";
exports.BUCKET_SPLASH_COPY = "Splash Fund";
/** The dashboard's per-period figure that is NOT the Splash Fund: the Flexible Spending
 *  share of this period's income, against flexible purchases that aren't bills. It was
 *  labelled "Splash Fund" beside Forecast's Splash Fund bucket, a different amount for
 *  the same person and period (Rule 2, 2026-10-14). Insights already names it this. */
exports.FLEXIBLE_SPENDING_TARGET_COPY = "Flexible Spending target";
exports.FLEXIBLE_SPENDING_TARGET_HINT_COPY = "This period's Flexible Spending share of your income, against what you've spent on flexible purchases that aren't bills. Your Splash Fund is on Forecast.";
/** The per-period PLANNED debt figure (minimums due plus your extra) only. */
exports.BUCKET_DEBT_PAYOFF_COPY = "Debt Payoff";
/** The MEASURED debt outflow (FA trailing-12-month average): a different quantity, so
 *  a different name (BEN-141, client-reported). */
exports.BUCKET_DEBT_PAID_COPY = "Debt Paid";
exports.BUCKET_LABELS = {
    income: exports.BUCKET_INCOME_COPY,
    needs: exports.BUCKET_NEEDS_COPY,
    wants: exports.BUCKET_WANTS_COPY,
    savings: exports.BUCKET_SAVINGS_COPY,
    "splash-fund": exports.BUCKET_SPLASH_COPY,
    debt: exports.BUCKET_DEBT_PAYOFF_COPY,
    "debt-allocation": exports.BUCKET_DEBT_PAYOFF_COPY,
    "debt-paid": exports.BUCKET_DEBT_PAID_COPY,
    // The API's spelling of the measured quantity (`/api/insights/`, FA); an alias, not a
    // fifth quantity (BEN-141 QF1: the fallback printed "debt_payments" to the reader).
    debt_payments: exports.BUCKET_DEBT_PAID_COPY,
};
/** Label for a bucket key, falling back to `fallback` (or the key) for unknown keys. */
function bucketLabel(key, fallback) {
    return exports.BUCKET_LABELS[key] ?? fallback ?? key;
}
/** Re-labels an OLD display string ("Needs", "Wants", "Savings", "Debt Allocation"),
 *  e.g. labels the API sends pre-rendered. Unrecognised strings pass through. */
const LEGACY_LABELS = {
    Needs: exports.BUCKET_NEEDS_COPY,
    Wants: exports.BUCKET_WANTS_COPY,
    Savings: exports.BUCKET_SAVINGS_COPY,
    "Debt Allocation": exports.BUCKET_DEBT_PAYOFF_COPY,
};
function relabelBucket(label) {
    return LEGACY_LABELS[label] ?? label;
}
//# sourceMappingURL=bucketLabels.js.map